import React, { useEffect, useState, useContext } from 'react'
import CIcon from '@coreui/icons-react'
import { cilPencil } from '@coreui/icons'
import {
  CButton,
  CCol,
  CFormInput,
  CFormLabel,
  CFormSwitch,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from '@coreui/react'
import moment from 'moment'
import SearchTable from 'src/components/searchTable'
import { checkPermissions, raiseToast } from 'src/views/utils/helper'
import { GlobalContext } from '../../context/GlobalState'
import { PERMISSIONS } from '../../utils/permissions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDoubleDown } from '@fortawesome/free-solid-svg-icons'
import useAxios from 'axios-hooks'
import { TAX_HEAD_API } from '../../utils/urls'
import { AppContext } from '../../context/app'

const TaxHead = () => {
  const { setLoader, accountObj } = useContext(AppContext)
  const [taxList, setTaxList] = useState([])
  const language = localStorage.getItem('language')
  const [openModal, setOpenModal] = useState(false)
  const [editTax, setEditTax] = useState(false)
  const [selectedTax, setSelectedTax] = useState({})
  // const [deleteModal, setDeleteModal] = useState(false)

  const [taxName, setTaxName] = useState('')
  const [taxPercent, setTaxPercent] = useState('')

  const [errorData, setErrorData] = useState({})

  const { userSessionObj } = useContext(GlobalContext)
  const defaultLangCheck = language === accountObj?.default_language
  const createAllowed =
    checkPermissions(userSessionObj.session_data.permissions, PERMISSIONS.PRICING.CREATE) &&
    defaultLangCheck
  const updateAllowed = checkPermissions(
    userSessionObj.session_data.permissions,
    PERMISSIONS.PRICING.UPDATE,
  )

  const [{ data: taxHeadList, loading: taxHeadListLoading }, taxHeadListCall] = useAxios(
    {
      url: TAX_HEAD_API,
      method: 'get',
    },
    { manual: true },
  )

  const [{ data: createTaxHead, loading: createTaxHeadLoading }, taxHeadCreateCall] = useAxios(
    {
      url: TAX_HEAD_API,
      method: 'post',
    },
    { manual: true },
  )

  const [{ data: updateTaxHead, loading: updateTaxHeadLoading }, taxHeadUpdateCall] = useAxios(
    {
      url: TAX_HEAD_API,
      method: 'put',
    },
    { manual: true },
  )

  useEffect(() => {
    taxHeadListCall()
  }, [])

  useEffect(() => {
    setLoader(taxHeadListLoading || createTaxHeadLoading || updateTaxHeadLoading)
  }, [taxHeadListLoading, createTaxHeadLoading, updateTaxHeadLoading])

  useEffect(() => {
    if (taxHeadList && taxHeadList.success) {
      let { data } = taxHeadList
      let tempArr = []
      data.forEach((ele) => {
        let tempEle = ele
        tempEle[`percentageText`] = `${ele.percentage_value}%`
        tempArr.push(tempEle)
      })
      setTaxList(tempArr)
    }
  }, [taxHeadList])

  useEffect(() => {
    if (createTaxHead && createTaxHead.success) {
      taxHeadListCall()
      emptyState()
      setOpenModal(false)
      raiseToast('success', 'Tax created successfully')
    }
  }, [createTaxHead])

  useEffect(() => {
    if (updateTaxHead && updateTaxHead.success) {
      taxHeadListCall()
      emptyState()
      setOpenModal(false)
      raiseToast('success', 'Tax updated successfully')
    }
  }, [updateTaxHead])

  const handleSubmit = async () => {
    if (validateInfo()) {
      const data = { name: taxName, percentage_value: taxPercent }
      editTax
        ? taxHeadUpdateCall({
            params: {
              tax_head_id: selectedTax._id,
            },
            data,
          })
        : taxHeadCreateCall({ data })
    }
  }

  const handleStatus = async (info) => {
    if (!updateAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }

    taxHeadUpdateCall({
      params: {
        tax_head_id: info._id,
      },
      data: { status: !info.status },
    })
  }

  const validateInfo = () => {
    let isFormValid = true
    let temp = {
      taxName: '',
      taxPercent: '',
    }

    if (taxName.trim().length === 0) {
      isFormValid = false
      temp.taxName = 'Name cannot be Empty!'
    }

    if (!taxPercent || taxPercent < 0 || taxPercent > 100) {
      isFormValid = false
      temp.taxPercent = 'Enter Value between 0 to 100!'
    }

    setErrorData({ ...temp })
    return isFormValid
  }

  const handleChange = (event, func) => {
    const { value, name } = event.target
    let temp = errorData
    temp[`${name}`] = ''
    setErrorData({ ...temp })
    func(value)
  }

  const handleEdit = (info) => {
    if (!updateAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }
    setEditTax(true)
    setSelectedTax(info)
    setTaxPercent(info.percentage_value)
    setTaxName(info.name)
    setOpenModal(true)
  }
  const emptyState = () => {
    setTaxPercent('')
    setTaxName('')
    setErrorData({})
    setSelectedTax({})
    setEditTax(false)
  }

  const tableConfig = [
    {
      header: 'Name',
      dataCell: (info) => info.name,
      width: 25,
    },
    {
      header: 'Percentage',
      dataCell: (info) => info.percentageText,
      width: 20,
    },
    {
      header: 'Created On',
      dataCell: (info) => moment.utc(info.created_date).format('DD-MM-YYYY'),
      width: 20,
    },
    {
      header: 'Status',
      dataCell: (info) => (
        <CFormSwitch
          label={info.status ? 'Active' : 'Disabled'}
          checked={info.status}
          valid={info.status}
          value={info.status}
          onChange={() => handleStatus(info)}
          size="lg"
        />
      ),
      width: 20,
    },
    {
      header: <FontAwesomeIcon icon={faAngleDoubleDown} size="lg" className="mx-1" />,
      dataCell: (info) => (
        <CIcon
          icon={cilPencil}
          style={{ cursor: 'pointer' }}
          size="lg"
          title="Edit"
          onClick={() => handleEdit(info)}
        />
      ),
      width: 10,
    },
  ]
  return (
    <>
      <h4>Tax</h4>
      <p>Create tax heads.</p>
      <SearchTable
        type={`Tax`}
        tableCardHeight={65}
        disableButton={false}
        buttonName={`+ Add`}
        buttonFunction={() => setOpenModal(!openModal)}
        searchTerm={`name`}
        tableConfig={tableConfig}
        tableContent={taxList}
        createPermission={createAllowed}
        disabledButtonTitle={defaultLangCheck ? '' : 'Adding Tax Available on Default Language'}
      />
      {/* ........modal......... */}
      <CModal size="lg" visible={openModal} alignment="center">
        <CModalHeader className="px-5 py-4">
          <CModalTitle>{editTax ? 'Edit ' : 'Add '}Tax Head</CModalTitle>
        </CModalHeader>
        <CModalBody className="px-5 py-4">
          <div className="mb-">
            <CRow>
              <CCol lg={6}>
                <CFormLabel>Tax Name*</CFormLabel>
                <CFormInput
                  type="text"
                  value={taxName}
                  name="taxName"
                  onChange={(e) => handleChange(e, setTaxName)}
                />
                <div className="message-text error-message">
                  <p>{errorData.taxName}</p>
                </div>
              </CCol>
              <CCol lg={6}>
                <CFormLabel>Percentage*</CFormLabel>
                <CFormInput
                  type="number"
                  value={taxPercent}
                  min="0"
                  max="100"
                  name="taxPercent"
                  onChange={(e) => handleChange(e, setTaxPercent)}
                />
                <div className="message-text error-message">
                  <p>{errorData.taxPercent}</p>
                </div>
              </CCol>
            </CRow>
          </div>
        </CModalBody>
        <CModalFooter>
          <CButton
            className="text-white"
            color="info"
            onClick={() => {
              emptyState()
              setOpenModal(false)
            }}
          >
            Cancel
          </CButton>
          <CButton className="text-white" color="info" onClick={handleSubmit}>
            Submit
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default TaxHead
